import { axios } from '@/lib/helpers';
import { createAction } from '@reduxjs/toolkit';

export const fetchShopDataStarted = createAction('shop/shop-data-fetch/started');
export const fetchShopDataFailed = createAction('shop/shop-data-fetch/failed');
export const fetchShopDataSucceeded = createAction('shop/shop-data-fetch/succeeded');

/**
 * @module redux-actions/shop-data
 * @deprecated
 * @todo Remove this file and use redux-api-slices/shop-data-api.js instead.
 */
export const fetchShopData = () => (dispatch, getState) => {
  dispatch(fetchShopDataStarted());

  const state = getState();
  const userState = state.user;
  let { user, chainUrls } = userState;

  return axios({
    method: 'get',
    crossdomain: true,
    url: `${chainUrls.GET_SHOP_DATA}userId=${user.uuid}`,
  }).then(
    ({ data }) => {
      if (data.result?.shopData) {
        dispatch(fetchShopDataSucceeded(data.result));
      } else {
        dispatch(fetchShopDataFailed());
      }
    },
    () => {
      dispatch(fetchShopDataFailed());
    }
  );
};
